import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TuiHintModule, TuiTextfieldControllerModule, TuiLabelModule } from "@taiga-ui/core";
import { TuiInputPasswordModule } from "@taiga-ui/kit";
import { KwikUIInputPasswordComponent } from "./input-password.component";

@NgModule({
  declarations: [KwikUIInputPasswordComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiHintModule,
    TuiInputPasswordModule,
    TuiTextfieldControllerModule,
    TuiLabelModule
  ],
  exports: [KwikUIInputPasswordComponent]
})
export class KwikUIInputPasswordModule {}
